"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Dropdown item that contains a button.
 */
const DropdownItemApplyButton = allProps => {
  const {
    eventKey,
    label,
    onClick,
    ...props
  } = allProps;
  const clickHandler = e => {
    e.stopPropagation();
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default.Item, {
    eventKey: eventKey,
    as: "div",
    bsPrefix: "dropdown-item cta",
    onClick: clickHandler
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    variant: "secondary",
    onClick: clickHandler
  }, props), label));
};
DropdownItemApplyButton.propTypes = {
  /** Enable/disable the button. */
  disabled: _propTypes.default.bool,
  /** The text content of the button. */
  label: _propTypes.default.string,
  /** The callback/handler when the button is clicked. */
  onClick: _propTypes.default.func
};
DropdownItemApplyButton.defaultProps = {
  disabled: false,
  label: 'Apply'
};
DropdownItemApplyButton.displayName = 'Dropdown.ApplyButton';
var _default = exports.default = DropdownItemApplyButton;